import type { ParsedUrlQuery } from 'querystring';
import type { ReactNode } from 'react';
import type { WidenMediaElement } from '@hub/libs/widen-utils';

export enum PRODUCT_TABS_KEY {
  PRODUCT_SELECTION,
  DESCRIPTION,
  TECHNICAL_DETAILS,
  SUITABLE_PRODUCTS,
  ONLINE_TOOLS,
  APPLICATION_EXAMPLES,
  DOWNLOAD_ASSETS,
}

export enum PRODUCT_DETAIL_COLLAPSIBLE_KEY {
  E_CHAIN_INSTALLATION_TYPE,
  E_CHAIN_MOUNTING_BRACKETS,
  E_CHAIN_INTERIOR_SEPARATION,
  E_CHAIN_SUPPORT_TRAYS,
  E_CHAIN_GUIDE_TROUGH,
}

export type Nullable<T> = T | null;

export type Category = {
  key: string;
  parentKey?: string;
  name: string;
  path: string;
  alternates: Record<string, string>;
  aliases: Record<string, string> | null;
  children?: Category[];
};

export interface TechnicalData {
  description: string;
  value: string | boolean;
  icon?: Nullable<string>;
  mediaElement?: Nullable<WidenMediaElement>;
}

export interface ContentItem {
  key?: PRODUCT_TABS_KEY | PRODUCT_DETAIL_COLLAPSIBLE_KEY;
  title: string;
  content: ReactNode;
  alternativeContent?: ReactNode;
}

export interface ProductDetailsParams extends ParsedUrlQuery {
  shape: string;
  categoryName: string;
}

export interface BearingHubPageParams extends ParsedUrlQuery {
  shape: string;
}

// from next-seo/lib/types.d.ts - not exported unfortunately
export interface LanguageAlternate {
  hrefLang: string;
  href: string;
  L?: string;
}

export interface CableToolsPostMessage {
  action: string;
  url?: string;
}

export enum KeyboardKeyName {
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',

  // internet explorer uses different names than specified
  IE_ARROW_LEFT = 'Left',
  IE_ARROW_RIGHT = 'Right',
  IE_ARROW_UP = 'Up',
  IE_ARROW_DOWN = 'Down',
}

export interface NextI18NextConfig {
  fallbackNS: string;
  fallbackLng: Record<string, string[]>;
  localePath: string;
  i18n: I18NextConfig;
}

export interface I18NextConfig {
  localeDetection?: boolean;
  defaultLocale: string;
  locales: string[];
  domains?: I18NextDomain[];
}

export interface I18NextDomain {
  domain: string;
  defaultLocale: string;
  locales?: string[];
}
